export type ContactLeadPayload = {
  source: 'contact-page' | 'quick-modal';
  fullName: string;
  email: string;
  message: string;
  phone?: string;
  company?: string;
  inquiryType?: string;
  budget?: string;
  service?: string | null;
};

type ContactApiSuccess = {
  ok: true;
  message: string;
};

type ContactApiError = {
  ok: false;
  message: string;
  errors?: Record<string, string>;
};

export type ContactApiResponse = ContactApiSuccess | ContactApiError;

export const CONTACT_ENDPOINT_NON_JSON_ERROR = 'CONTACT_ENDPOINT_NON_JSON';

function buildContactEndpoint() {
  const normalizedBase = __BASE_PATH__.endsWith('/') ? __BASE_PATH__ : `${__BASE_PATH__}/`;
  const url = new URL(`api/send-contact.php`, window.location.origin + normalizedBase);
  return url.toString();
}

export async function sendContactLead(payload: ContactLeadPayload): Promise<ContactApiResponse> {
  const response = await fetch(buildContactEndpoint(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const contentType = response.headers.get('content-type') ?? '';

  if (!contentType.includes('application/json')) {
    throw new Error(CONTACT_ENDPOINT_NON_JSON_ERROR);
  }

  return (await response.json()) as ContactApiResponse;
}
